import { useContext } from "react";
import { PersonFiltersContext } from "../../../../context/FiltersContext";
import { QueryFilter, PersonFilterKeys } from "../../../../interfaces/filters";
import { AccordionFilterItem } from "../../../accordion/Accordion";
import PersonKommuneFilter from "./PersonKommuneFilter";
import PersonLandeFilter from "./PersonLandeFilter";
import PersonPostnummerFilter from "./PersonPostnummerFilter";
import PersonRetskredsFilter from "./PersonRetskredsFilter";
import PersonVejnavnFilter from "./PersonVejnavnFilter";
import PersonRegionFilter from "./PersonRegionFilter";
import PersonAdvokatkredsFilter from "./PersonAdvokatkredsFilter";

// helper
const filterKeys: Array<QueryFilter<PersonFilterKeys>["filterKey"]> = [
  "vejnavn",
  "postnummer",
  "kommune",
  "region",
  "country",
  "advokatkreds",
  "retskreds",
];

export default function PersonGeografiFilter() {
  // query filter context
  const filters = useContext(PersonFiltersContext);

  // find the filter settings
  const allSettings = filters.flatMap((set) => {
    if (set.filterKey === filterKeys.find((key) => key === set.filterKey)) {
      return set;
    } else {
      return [];
    }
  });

  // check if any settings are active
  const hasAnyActiveSetting = allSettings.some((set) => set.settings);

  return (
    <AccordionFilterItem
      title="Geografi"
      value="geografi"
      isActive={hasAnyActiveSetting}
    >
      <PersonVejnavnFilter />
      <PersonPostnummerFilter />
      <PersonKommuneFilter />
      <PersonRegionFilter />
      <PersonLandeFilter />
      <PersonAdvokatkredsFilter />
      <PersonRetskredsFilter />
    </AccordionFilterItem>
  );
}
